export * from './watch-video.component';
